module.exports = __webpack_public_path__ + "img/256.proper_performance.e9fa375d.svg";